import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";

function ExperienceEntry({ item }) {
  return (
    <>
      <div className="timeline-header">
        <div className="timeline-role">{item.role}</div>
        <div className="timeline-date">{item.date}</div>
      </div>
      <div className="timeline-org">{item.org}</div>
      <List dense disablePadding sx={{ mt: 0.5 }}>
        {item.bullets.map((bullet) => (
          <ListItem disableGutters key={bullet} sx={{ py: 0.4 }}>
            <ListItemText
              primary={bullet}
              primaryTypographyProps={{
                sx: { color: "var(--ink-dim)", fontSize: "0.95rem", fontWeight: 400, lineHeight: 1.8 },
              }}
            />
          </ListItem>
        ))}
      </List>
    </>
  );
}

export default ExperienceEntry;
